import LeaderboardsApi from './LeaderboardsApi'

export default LeaderboardsApi
